





















import {Component} from 'vue-property-decorator'
import {mixins} from 'vue-class-component'
import BookingDetailMixin from '@/lib/BookingDetailMixin'
import Utils from '@/utils'

@Component({
  components: {
    BookingActions: Utils.loadComponent('BookingActions'),
    ReservationVehicleAndDates: Utils.loadComponent('entities/reservation/ReservationVehicleAndDates'),
    HorizontalHighlight: Utils.loadComponent('HorizontalHighlight'),
    Card: Utils.loadComponent('proxy/Card/Card'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Container: Utils.loadComponent('proxy/Container'),
    CardTitle: Utils.loadComponent('proxy/Card/CardTitle'),
    TripList: Utils.loadComponent('entities/reservation/TripList'),
    VehicleLotAndDistance: Utils.loadComponent('entities/vehicle/VehicleLotAndDistance'),
    Divider: Utils.loadComponent('proxy/Divider'),
  },
  name: 'HistoryBookingDetail',
  mixins: [BookingDetailMixin],
})
export default class HistoryBookingDetail extends mixins<BookingDetailMixin>(BookingDetailMixin) {}
